/**
 * Where a printed document pulls an order photo from: the app's own route,
 * deliberately.
 *
 * Not the signed S3 URL that `OrderResource` sends alongside it on every image
 * row, tempting as it is — that one streams nothing through the app server, and
 * a 25-order bulk print is up to 175 full-size photos the box does not have to
 * carry. It does not work. react-pdf reads images with `fetch`, so the response
 * needs CORS headers, and the bucket serves none: a plain GET of a signed URL
 * returns 200, the same GET carrying an `Origin` header comes back without a
 * single `Access-Control-*` header, the browser withholds the bytes, and every
 * picture renders as an empty box. This route goes through Laravel, whose CORS
 * config covers `api/*` with `allowed_origins: ['*']`, so the fetch succeeds.
 *
 * To move to S3, put a CORS rule on the bucket first — GET from the app's
 * origin — and check that `Access-Control-Allow-Origin` comes back on a signed
 * URL. Then this becomes `img.url || <the route below>`. Not before: no test in
 * this repo can catch the regression, because the layout suite renders in Node
 * against local files and never makes a cross-origin request.
 *
 * Its own module so it is one decision in one place, and so tests can put a
 * readable local file in front of the renderer.
 */
export const imageSrc = (img) =>
  `${process.env.REACT_APP_API_BASE_URL}/files/upload/${img.id}`;
